import { render, staticRenderFns } from "./LatestPages.vue?vue&type=template&id=43f60b11&scoped=true&"
import script from "./LatestPages.vue?vue&type=script&lang=js&"
export * from "./LatestPages.vue?vue&type=script&lang=js&"
import style0 from "./LatestPages.vue?vue&type=style&index=0&id=43f60b11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f60b11",
  null
  
)

export default component.exports